import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const BreadcrumbsContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  color: #3e3e3e; /* {theme.palette.colors.black} */
  text-decoration: none;
  margin-top: 20px;
  @media (min-width: 1180px) {
    padding: 0 20px 20px 0;
  }
`;

const Breadcrumbs = ({ children, innerStyle }) => {
  return (
    <BreadcrumbsContainer
      itemScope
      itemType="http://schema.org/BreadcrumbList"
      style={innerStyle}
    >
      {children}
    </BreadcrumbsContainer>
  );
};

Breadcrumbs.propTypes = {
  children: PropTypes.node.isRequired,
  innerStyle: PropTypes.object,
};

Breadcrumbs.defaultProps = {
  innerStyle: undefined,
};

export default Breadcrumbs;
